<div class="relative pb-1 tablet:pb-1.5">
  <div
    class="rounded border h-[42px] flex items-center pr-1.5 bg-white text-mobileMd tablet:text-mobileMd desktop:text-desktopMd w-full"
    [ngClass]="{
      'border-primaryRed': errorMessage() && !isFocused,
      'border-black': !errorMessage() || isFocused,
    }"
  >
    <input
      class="rounded-l h-full block focus:outline-none pl-3 py-2 w-full"
      type="text"
      [ngStyle]="{ '-webkit-text-security': !isShow ? 'disc' : 'none' }"
      [placeholder]="placeholder()"
      [value]="value || ''"
      (input)="onInput($event)"
      [id]="id()"
      [attr.aria-invalid]="ariaInvalid()"
      [attr.aria-describedby]="ariaDescribedBy()"
      [autocomplete]="autocomplete()"
      #input
      [attr.aria-invalid]="!isValid()"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
    <sc-button variant="icon" [padding]="false" (click)="toggleShow()">
      @if (isShow) {
        <sc-svg name="eye" size="w-6 h-6"></sc-svg>
      } @else {
        <sc-svg name="eye-cross" size="w-6 h-6"></sc-svg>
      }
    </sc-button>
    @if (errorMessage() && !isFocused) {
      <p class="text-primaryRed absolute -bottom-1/2 mb-2 left-0 text-sm tablet:text-base">
        {{ errorMessage() | scTranslate | async }}
      </p>
    }
  </div>
</div>
